/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoServicenowProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-servicenow-prod" */ './utils').then(
			(m) => m.ForgeUnitoServicenowProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-prod/icon' },
);

const LazyForgeUnitoServicenowProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-servicenow-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoServicenowProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoServicenowProdIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoServicenowProdIconComponent />
	</Suspense>
);

export const ForgeUnitoServicenowProdSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoServicenowProdSearchResultIconComponent />
	</Suspense>
);
